import { Button, Col, Form, Input, message, Row } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import * as React from 'react';
import 'src/assets/less/index.less';
import { IPageResult } from 'src/entity/BaseResult';
import { IDoctorInfo } from 'src/entity/DoctorEntity';
import { IDoctorSearch } from 'src/entity/SearchEntity';
import DoctorService from 'src/services/DoctorService';
import I18N from 'src/services/I18NService';

interface IAuditSearchFormProps extends FormComponentProps {
  selectTab: number;
  isDomestic: boolean;
  onRef(obj: AuditSearchForm): void;
  cbSearch(obj: IPageResult<IDoctorInfo[]>): void;
}

/**
 * 代理商医生审核列表查询
 * @class AuditSearchForm
 * @extends {React.Component<IAuditSearchFormProps>}
 */
class AuditSearchForm extends React.Component<IAuditSearchFormProps> {
  constructor(props: IAuditSearchFormProps) {
    super(props);
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  handleSearch = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.doSearch(this.props.selectTab);
  };

  doSearch = (selectTab: number = 1, offset: number = 0, limit: number = 10) => {
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        try {
          const query: IDoctorSearch = {
            limit,
            offset,
            fullname: values.name,
            mobile: values.phone,
            email: values.email,
          };
          switch (selectTab) {
            case 1:
              // 待审核列表
              // query = {
              //   limit,
              //   offset,
              //   check__isnull: true,
              //   fullname: values.name,
              //   mobile: values.phone,
              //   email: values.email,
              //   is_verified__isnull: true,
              // };
              query.check__isnull = true;
              query.is_verified__isnull = true;
              break;
            case 2:
              // 待认证列表
              // query = {
              //   limit,
              //   offset,
              //   fullname: values.name,
              //   mobile: values.phone,
              //   email: values.email,
              //   is_certified__isnull: true,
              // };
              query.is_certified__isnull = true;
              // const certifyDoctorList: IPageResult<IDoctorInfo[]> = await DoctorService.getAgentDoctor(query);
              // // const certifyDoctorList: IPageResult<ICertificationDoctorInfo[]> = await DoctorService.getToBeCertifiedDoctorList(query);
              // this.props.cbSearch(certifyDoctorList);
              break;
            case 3:
              // 审核驳回医生列表
              // query = {
              //   limit,
              //   offset,
              //   fullname: values.name,
              //   mobile: values.phone,
              //   email: values.email,
              //   is_verified: false,
              // };
              query.is_verified = false;
              // const rejectDoctorList: IPageResult<IDoctorInfo[]> = await DoctorService.getAgentDoctor(query);
              // this.props.cbSearch(rejectDoctorList);
              break;
            default:
              break;
          }
          const doctorList: IPageResult<IDoctorInfo[]> = await DoctorService.getAgentDoctor(query);
          this.props.cbSearch(doctorList);
        } catch (error) {
          if (!!error.response) {
            message.error(JSON.stringify(error.response.data));
          } else {
            message.error(I18N.get('err_search_failure'));
          }
        }
      }
    });
  };

  handleReset = () => {
    this.props.form.resetFields();
  };

  render() {
    const { isDomestic } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <Form className="mdd-search-form" onSubmit={this.handleSearch}>
        <Row type="flex" align="middle" justify="center" gutter={24}>
          <Col span={4}>
            <Form.Item label={I18N.get('common_name')} style={{ marginBottom: 0 }}>
              {getFieldDecorator(`name`)(<Input placeholder={I18N.get('common_name')} />)}
            </Form.Item>
          </Col>
          {isDomestic && (
            <Col span={4}>
              <Form.Item label={I18N.get('common_mobile')} style={{ marginBottom: 0 }}>
                {getFieldDecorator(`phone`)(<Input placeholder={I18N.get('common_mobile')} />)}
              </Form.Item>
            </Col>
          )}
          {!isDomestic && (
            <Col span={4}>
              <Form.Item label="Email" style={{ marginBottom: 0 }}>
                {getFieldDecorator(`email`)(<Input placeholder="email" />)}
              </Form.Item>
            </Col>
          )}
          <div className="fixed-flex-item" style={{ marginLeft: 12 }}>
            <Button type="primary" htmlType="submit">
              {I18N.get('common_search')}
            </Button>
            <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>
              {I18N.get('common_clear')}
            </Button>
          </div>
        </Row>
      </Form>
    );
  }
}

const AuditSearch = Form.create<IAuditSearchFormProps>()(AuditSearchForm);
export default AuditSearch;



// WEBPACK FOOTER //
// ./src/components/custom/AuditSearch.tsx